import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ITenant } from './interfaces/tenant.interface';

@Injectable()
export class TenantApiService {
  private httpClient = inject(HttpClient);

  loadPersonalTenants(): Observable<ITenant[]> {
    const headers: { [header: string]: string } = { 'x-tenant-id': 'public' };
    return this.httpClient.get<ITenant[]>(`/api/tenant`, { headers });
  }
}
